// Helper function to truncate crypto addresses
export const truncateAddress = (
  address: string,
  n: number = 6,
  m: number = 6
) => {
  if (!address) return "";
  if (address.length <= n + m) return address;
  return `${address.slice(0, n)}...${address.slice(-m)}`;
};
